<template>
  <div>
    <router-view />
    <van-tabbar route :safe-area-inset-bottom="true">
      <van-tabbar-item
        :to="item.path"
        v-for="(item, index) in tabBar"
        :key="index"
      >
        <span>{{ item.name }}</span>
        <template #icon="props">
          <img :src="props.active ? item.active : item.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import home from '@/assets/icon／首页.png';
import homeActive from '@/assets/icon／首页-选中.png';

import buy from '@/assets/icon／立即下单.png';
import buyActive from '@/assets/icon／立即下单-选中.png';
import order from '@/assets/icon／订单.png';
import orderActive from '@/assets/icon／订单-选中.png';
import my from '@/assets/icon／我的.png';
import myActive from '@/assets/icon／我的-选中.png';
export default {
  data() {
    return {
      active: 0,
      tabBar: [
        { name: '首页', path: '/', inactive: home, active: homeActive },
        { name: '立即下单', path: '/buy', inactive: buy, active: buyActive },
        { name: '订单', path: '/order', inactive: order, active: orderActive },
        { name: '我的', path: '/user', inactive: my, active: myActive }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.van-tabbar {
  height: 13.067vw;
}
.van-tabbar-item--active {
  color: #f93244;
}
.van-tabbar-item__icon img {
  width: 6.4vw;
  height: 6.4vw;
}
.van-tabbar-item__text {
  span {
    font-size: 2.667vw;
  }
}
</style>
